"use client";

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    return (
        <html>
            <body>
                <div
                    style={{
                        margin: 0,
                        minHeight: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "linear-gradient(135deg, #FFEDF6, #DFD9FF)",
                        fontFamily: "'Quicksand', sans-serif",
                        overflow: "hidden",
                        position: "relative",
                    }}
                >
                    {/* eslint-disable-next-line @next/next/no-page-custom-font */}
                    <link
                        href="https://fonts.googleapis.com/css2?family=Quicksand:wght@500;700&display=swap"
                        rel="stylesheet"
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                            position: "relative",
                            zIndex: 10,
                        }}
                    >
                        {/* Ghost */}
                        <div
                            style={{
                                position: "relative",
                                width: 300,
                                height: 280,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <div style={{ position: "relative", animation: "ghost-float 4s ease-in-out infinite", zIndex: 5 }}>
                                <div
                                    style={{
                                        position: "relative",
                                        width: 150,
                                        height: 170,
                                        background: "#FFFFFF",
                                        borderRadius: "75px 75px 0 0",
                                        boxShadow: "inset -10px -10px 20px rgba(0,0,0,0.03), 0 10px 30px rgba(140, 120, 179, 0.15)",
                                    }}
                                >
                                    {/* Face with X eyes */}
                                    <div style={{ position: "absolute", top: 60, left: 0, width: "100%", height: 60 }}>
                                        <div style={{ position: "absolute", top: 2, left: 42, fontSize: 20, fontWeight: 700, color: "#3B3349" }}>✕</div>
                                        <div style={{ position: "absolute", top: 2, right: 42, fontSize: 20, fontWeight: 700, color: "#3B3349" }}>✕</div>
                                        <div style={{ position: "absolute", top: 15, left: 20, width: 24, height: 12, background: "#FFB3C6", borderRadius: "50%", filter: "blur(3px)", opacity: 0.8 }} />
                                        <div style={{ position: "absolute", top: 15, right: 20, width: 24, height: 12, background: "#FFB3C6", borderRadius: "50%", filter: "blur(3px)", opacity: 0.8 }} />
                                        <div style={{ position: "absolute", top: 22, left: 62, fontSize: 18, color: "#3B3349" }}>~</div>
                                    </div>

                                    {/* Skirt */}
                                    <div style={{ position: "absolute", bottom: -15, left: 0, width: "100%", display: "flex" }}>
                                        {[0, 1, 2, 3].map((i) => (
                                            <div key={i} style={{ flex: 1, height: 30, background: "#FFFFFF", borderRadius: "0 0 50% 50%", boxShadow: "inset 0 -4px 8px rgba(0,0,0,0.02)" }} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Text */}
                        <div style={{ marginTop: 10 }}>
                            <h1 style={{ fontSize: "3.4rem", color: "#4A3E5C", margin: 0, letterSpacing: -2, fontFamily: "'Quicksand', sans-serif" }}>
                                Oops!
                            </h1>
                            <h2 style={{ fontSize: "1.4rem", color: "#5D4F70", margin: "5px 0 10px 0", fontFamily: "'Quicksand', sans-serif" }}>
                                Something went very wrong
                            </h2>
                            <p style={{ fontSize: "1rem", color: "#8C78B3", margin: "0 0 30px 0", fontWeight: 500, fontFamily: "'Quicksand', sans-serif" }}>
                                Our ghost got spooked. Let&apos;s try again.
                            </p>
                            <button
                                onClick={reset}
                                style={{
                                    background: "#FFFFFF",
                                    color: "#8C78B3",
                                    border: "none",
                                    padding: "14px 38px",
                                    borderRadius: 30,
                                    fontSize: "1.1rem",
                                    fontFamily: "'Quicksand', sans-serif",
                                    fontWeight: 700,
                                    cursor: "pointer",
                                    boxShadow: "0 8px 20px rgba(140, 120, 179, 0.15)",
                                }}
                            >
                                Try again
                            </button>
                        </div>
                    </div>

                    <style>{`
                        @keyframes ghost-float {
                            0%, 100% { transform: translateY(0); }
                            50% { transform: translateY(-15px); }
                        }
                    `}</style>
                </div>
            </body>
        </html>
    );
}
